/****************************************
 	Carousel
 *****************************************/
;(function ($) {
	"use strict";
	var Carousel = {},
		version = 2,
		doubleIncluded = !!$.carousel;
	if (doubleIncluded) {
		if ($.carousel.version === version) {
			if (window.console) {
				console.warn('ERROR: You are including carousel.js multiple times');
			}
			return;
		} else {
			if (window.console) {
				console.warn('ERROR: You are including multiple versions of carousel.js');
			}
			if ($.carousel.version > version) {
				return;
			}
		}
	}
	/* Set Defaults */
	Carousel.defaults = {
		'fullWidth': true, /* Set true for a full width carousel (one slide in view at a time) or false for a floated gallery (floated / multiple slides in view) */
		'showPreviews': false, /* Set true to show a preview (64px by default) of the previous and next slide */
		'carouselHeight': 'auto', /* ('auto' | 'varied' | CSS value ) 'auto' = No height is set, which means the carousel will default to the height of the tallest slide; 'varied' = Height varies with each slide and animates on each scroll; CSS value = Enter a CSS value (in px, em, %, etc) to manually set height of carousel; */
		'firstSlide': 1, /* Set first slide */
		'slidesPerScroll': 'page', /* Accepts 'page' or number. Only applies to galleries with 'fullWidth': false. 'page' = scrolls the number of slides fully visible in the viewport. number = scroll a specific number of slides at a time. */
		'continuous': false, /* Set true to make slides continue to first slide at the end */
		'infinite': false, /* Shows 3 slides and scrolls infinitely; you are responsible for dynamically populating slide content. */
		'pagination': null, /* Set to 'numbers' or 'dots' to turn on pagination */
		'showPrevNextBtns': true, /* Set false to turn off prev / next buttons */
		'showPausePlayBtns': false, /* Set true to turn on pause / play button (if autoscroll is set) */
		'autoscroll': 0, /* Delay time between autoscroll slides (0 = autoscroll off) */
		'scrollTime': 400, /* Animation time to scroll */
		'playOnLoad': true, /* Set false to pause autoscroll on load */
		'pausePlayBtnClass': 'carouselPausePlayBtn', /* Class for pause / play toggle button */
		'activeSlideClass': 'carouselActiveSlide', /* Class for active slide */
		'activeBtnClass': 'active', /* Class for active button (pagination) */
		'disabledBtnClass': 'disabled', /* Class for disabled button (pagination) */
		'onSlideStart': false, /* DEPRECATED (use onSlideLoad instead): function (slideIndex, $slide) { } Callback at start of slide */
		'onSlideEnd': false, /* DEPRECATED (use onSlideChange instead): function (slideIndex, $slide) { } Callback at end of slide */
		'onSlideLoad': false, /* function (slideIndex, $slide, previousSlideIndex, $previousSlide) { } Callback for when the slide loads */
		'onSlideChange': false, /* function (slideIndex, $slide, previousSlideIndex, $previousSlide) { } Callback that occurs each time a slide changes */
		'onAfterSlideChange': false /* function (slideIndex, $slide, previousSlideIndex, $previousSlide) { } Callback that occurs AFTER each time a slide changes */
	};
	/* Detect touch device */
	Carousel.isTouchDevice = 'ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch);
	/* Detect iPad */
	Carousel.isIpad = navigator.userAgent.match(/iPad/i) !== null;
	/* Functions */
	function setPositions($el) {
		var settings = $el.data('carousel'),
			$inner = $el.data('$carouselInner'),
			$slides,
			$lastSlide,
			lastSlideIndex,
			carouselWidth,
			maxLeftPosition;
		/* If # of slides is different than before, update $carouselSlides */
		if (settings.infinite) {
			$el.data('$carouselSlides', $el.find('.carouselSlide'));
		}
		/* Update the variables based on how many slides there are now */
		$slides = $el.data('$carouselSlides');
		$lastSlide = $slides.eq(-1);
		lastSlideIndex = $lastSlide.index();
		carouselWidth = $lastSlide.position().left + $lastSlide.outerWidth(true);
		if (carouselWidth <= $el.outerWidth(false)) {
			$slides.data('carousel-position', 0);
		} else if (settings.fullWidth) {
			/* maxLeftPosition = last slide's left position */
			maxLeftPosition = -$lastSlide.position().left - parseInt($lastSlide.css('margin-left'), 10);
			/* (For fullWidth) Store position of each slide */
			$slides.each(function () {
				$(this).data('carousel-position', ((-$(this).position().left - parseInt($(this).css('margin-left'), 10)) / $(this).outerWidth(false)) * 100 + '%');
			});
		} else {
			/* maxLeftPosition = carouselWidth - stageWidth */
			maxLeftPosition = $inner.width() - carouselWidth;
			/* (For galleries) Store position of each slide */
			$slides.each(function () {
				$(this).data('carousel-position', -$(this).position().left - parseInt($(this).css('margin-left'), 10));
				/* If slide's position < maxLeftPosition, set current slide position with maxLeftPosition and don't set position of any slides that follow */
				if ($(this).data('carousel-position') <= maxLeftPosition) {
					$(this).data('carousel-position', maxLeftPosition);
					$lastSlide = $(this);
					lastSlideIndex = $(this).index();
					return false;
				}
			});
		}
		/* Set height if passed in settings */
		if (settings.carouselHeight !== 'auto' && settings.carouselHeight !== 'varied') {
			$slides.css('min-height', settings.carouselHeight);
		}
		/* Hide any controls that goTo a slide / page past the lastSlideIndex */
		if ($el.data('$carouselGoToSlideBtns')) {
			$el.data('$carouselGoToSlideBtns').each(function () {
				if ($(this).attr('data-carousel-slide') > lastSlideIndex) {
					$(this).fadeOut();
				} else {
					$(this).fadeIn();
				}
			});
		}
		/* Store variables for later use */
		$el
			.data('$lastSlide', $lastSlide)
			.data('carousel-stage-width', carouselWidth);
	}
	function markCarousel($el, oldSlideIndex, newSlideIndex) {
		var settings = $el.data('carousel'),
			$slides = $el.data('$carouselSlides'),
			$lastSlide = $el.data('$lastSlide'),
			lastSlideIndex = $lastSlide.index(),
			elMatchingIdAttr = '[data-carousel-id="' + $el.attr('id') + '"]',
			$nextBtns,
			$previousBtns,
			$firstBtns,
			$lastBtns;
		/* Store and mark current slide */
		$el.data('$currentSlide', $slides.eq(newSlideIndex));
		$slides
			.eq(oldSlideIndex)
			.removeClass(settings.activeSlideClass)
			.end()
			.eq(newSlideIndex)
			.addClass(settings.activeSlideClass);
		/* Remove animating class (added in goToSlide function) */
		$el.removeClass('carouselAnimating');
		/* disable buttons when they are not enabled */
		if (!settings.continuous && !settings.infinite) {
			$nextBtns = $(elMatchingIdAttr + '[data-carousel-slide="next"]');
			$previousBtns = $(elMatchingIdAttr + '[data-carousel-slide="previous"]');
			$firstBtns = $(elMatchingIdAttr + '[data-carousel-slide="first"]');
			$lastBtns = $(elMatchingIdAttr + '[data-carousel-slide="last"]');
			if ($el.data('carousel-stage-width') <= $el.outerWidth(false)) {
				$nextBtns
					.add($previousBtns)
					.add($firstBtns)
					.add($lastBtns)
					.addClass(settings.disabledBtnClass)
					.attr('disabled', 'disabled');
			} else if (newSlideIndex === 0) {
				/* When on first slide... */
				$previousBtns
					.add($firstBtns)
					.addClass(settings.disabledBtnClass)
					.attr('disabled', 'disabled');
				$nextBtns
					.add($lastBtns)
					.removeClass(settings.disabledBtnClass)
					.removeAttr('disabled');
			} else if (newSlideIndex === lastSlideIndex) {
				/* When on "last" slide... */
				$nextBtns
					.add($lastBtns)
					.addClass(settings.disabledBtnClass)
					.attr('disabled', 'disabled');
				$previousBtns
					.add($firstBtns)
					.removeClass(settings.disabledBtnClass)
					.removeAttr('disabled');
			} else {
				/* Any other slide... */
				$nextBtns
					.add($previousBtns)
					.add($firstBtns)
					.add($lastBtns)
					.removeClass(settings.disabledBtnClass)
					.removeAttr('disabled');
			}
		}
		/* Mark pagination */
		if (!settings.infinite) {
			$(elMatchingIdAttr + '[data-carousel-slide="' + oldSlideIndex + '"]').removeClass(settings.activeBtnClass);
			$(elMatchingIdAttr + '[data-carousel-slide="' + newSlideIndex + '"]').addClass(settings.activeBtnClass);
		}
	}
	function goToSlide($el, newSlideIndex, ignoreCallbacks) {
		var settings = $el.data('carousel'),
			$inner = $el.data('$carouselInner'),
			$slides = $el.data('$carouselSlides'),
			$lastSlide = $el.data('$lastSlide'),
			lastSlideIndex = $lastSlide.index(),
			$currentSlide = $el.data('$currentSlide'),
			currentSlideIndex = $currentSlide.index(),
			currentSlidePosition = $currentSlide.data('carousel-position'),
			elWidth = $el.width(),
			leftPosition = 0,
			positionOptions = {},
			slidesToScroll = (settings.slidesPerScroll === 'page') ? $slides.length : settings.slidesPerScroll,
			i;
		/* If newSlideIndex is a string / keyword, calculate to number */
		if ($.type(newSlideIndex) === 'string') {
			if (newSlideIndex === 'next') {
				if (settings.continuous && currentSlideIndex >= lastSlideIndex) {
					/* If continuous & on lastSlideIndex, set newSlideIndex to first slide */
					newSlideIndex = 0;
				} else {
					newSlideIndex = currentSlideIndex + slidesToScroll;
					/* If newSlide doesn't fit in the viewport, find the last slide that does */
					if (slidesToScroll > 1) {
						i = currentSlideIndex + 1;
						while (i <= currentSlideIndex + slidesToScroll) {
							if (Math.abs($slides.eq(i).data('carousel-position')) + $slides.eq(i).width() - Math.abs(currentSlidePosition) > elWidth) {
								newSlideIndex = Math.max(i, currentSlideIndex + 1);
								break;
							}
							i += 1;
						}
					}
				}
			} else if (newSlideIndex === 'previous') {
				if (settings.continuous && currentSlideIndex <= 0) {
					/* If continuous & on first slide, set newSlideIndex to last slide */
					newSlideIndex = lastSlideIndex;
				} else {
					/* Calculate newSlideIndex */
					newSlideIndex = currentSlideIndex - slidesToScroll;
					/* If newSlide doesn't fit in the viewport, find the last slide that does */
					if (slidesToScroll > 1) {
						i = currentSlideIndex - 1;
						while (i >= currentSlideIndex - slidesToScroll) {
							if (Math.abs(currentSlidePosition) - parseInt($slides.eq(currentSlideIndex - 1).css('margin-right'), 10) - parseInt($currentSlide.css('margin-left'), 10) - Math.abs($slides.eq(i).data('carousel-position')) > elWidth) {
								newSlideIndex = Math.min(i + 1, currentSlideIndex - 1);
								break;
							}
							i -= 1;
						}
					}
				}
			} else if (newSlideIndex === 'last') {
				newSlideIndex = lastSlideIndex;
			} else if (newSlideIndex === 'first') {
				newSlideIndex = 0;
			}
		}
		/* Ensure newSlideIndex is a number so markCarousel works properly */
		newSlideIndex = parseInt(newSlideIndex, 10);
		/* Restrict newSlideIndex to be between 0 (firstSlide) and lastSlide */
		if (newSlideIndex < 0) {
			newSlideIndex = 0;
		} else if (newSlideIndex > lastSlideIndex) {
			newSlideIndex = lastSlideIndex;
		}
		/* Run callbacks */
		if (!ignoreCallbacks) {
			if (settings.onSlideEnd !== false) {
				settings.onSlideEnd(currentSlideIndex, $currentSlide);
			}
			if (settings.onSlideStart !== false) {
				settings.onSlideStart(newSlideIndex, $slides.eq(newSlideIndex));
			}
			if (settings.onSlideChange !== false) {
				settings.onSlideChange(newSlideIndex, $slides.eq(newSlideIndex), currentSlideIndex, $currentSlide);
			}
		}
		if (settings.onSlideLoad !== false && !$slides.eq(newSlideIndex).data('carousel-loaded')) {
			settings.onSlideLoad(newSlideIndex, $slides.eq(newSlideIndex));
			$slides.eq(newSlideIndex).data('carousel-loaded', true);
		}
		/* Set leftPosition */
		leftPosition = $slides.eq(newSlideIndex).data('carousel-position');
		/* Set position options to animate */
		$el.addClass('carouselAnimating');
		if (settings.carouselHeight === 'varied') {
			positionOptions.height = $slides.eq(newSlideIndex).outerHeight(true);
		}
		/* Animate */
		$inner.css(buildAnimation(leftPosition, positionOptions, settings));
		/* On after slide change callback */
		if (!ignoreCallbacks && settings.onAfterSlideChange !== false) {
			setTimeout(function () {
				if (settings.infinite) {
					$el.data('$currentSlide', $slides.eq(settings.firstSlide - 1));
					$inner.css(buildAnimation($slides.eq(settings.firstSlide - 1).data('carousel-position'), {
						'-webkit-transition': 'none',
						'transition': 'none'
					}, settings));
				}
				settings.onAfterSlideChange(newSlideIndex, $slides.eq(newSlideIndex), currentSlideIndex, $currentSlide);
			}, settings.scrollTime);
			if (settings.infinite) {
				$inner.css({
					'-webkit-transition': settings.innerTransition,
					'transition': settings.innerTransition
				});
			}
		}
		/* Mark carousel */
		markCarousel($el, currentSlideIndex, newSlideIndex);
	}
	function buildAnimation(leftPosition, cssObject, settings) {
		if (settings.useTransforms) {
			cssObject.transform = 'translate3d(' + leftPosition + ', 0, 0)';
		} else {
			cssObject.left = leftPosition;
		}
		return cssObject;
	}
	function getLeftPosition($el, settings) {
		var matrix,
			x;
		if (settings.useTransforms) {
			matrix = window.getComputedStyle($el.data('$carouselInner')[0], null);
			matrix = matrix.transform.split(')')[0].split(', ');
			x = parseInt(matrix[12] || matrix[4], 10);
		} else {
			x = parseInt($el.data('$carouselInner').css('left'), 10);
		}
		return x;
	}
	function playAutoscroll($el) {
		var settings = $el.data('carousel'),
			$pausePlayBtns = $('.' + settings.pausePlayBtnClass + '[data-carousel-id="' + $el.attr('id') + '"]');
		$el
			.removeClass('carouselPaused')
			.addClass('carouselPlaying');
		$pausePlayBtns
			.removeClass('iconPlay')
			.addClass('iconPause');
		$el.data('carousel-timer', setInterval(function () {
			goToSlide($el, 'next');
		}, settings.autoscroll + settings.scrollTime));
	}
	function pauseAutoscroll($el, forceStop) {
		var settings = $el.data('carousel'),
			$pausePlayBtns = $('.' + settings.pausePlayBtnClass + '[data-carousel-id="' + $el.attr('id') + '"]');
		$el
			.addClass('carouselPaused')
			.removeClass('carouselPlaying');
		clearInterval($el.data('carousel-timer'));
		if (forceStop) {
			$el
				.data('carousel-timer', null)
				.removeClass('carouselPaused carouselPlaying');
			$pausePlayBtns
				.removeClass('iconPause')
				.addClass('iconPlay');
		}
	}
	function addControlsHtml($el) {
		var settings = $el.data('carousel'),
			elId = $el.attr('id'),
			lastSlideIndex = $el.data('$carouselSlides').eq(-1).index(),
			html = '',
			$prevNextBtns,
			$pagination,
			$pausePlayBtns,
			$controlsWrap,
			i = 0;
		if (!$el.find('.carouselControlsDefault').length) {
			$('<menu class="carouselControlsDefault"></menu>').appendTo($el);
		}
		$controlsWrap = $el.find('.carouselControlsDefault');
		if (settings.showPausePlayBtns && !$el.data('carousel-pause-play-loaded')) {
			$pausePlayBtns = $('<button class="' + settings.pausePlayBtnClass + ' ancBtn icon iconPause silver sml" type="button" data-carousel-id="' + elId + '"></button>');
			$pausePlayBtns.appendTo($controlsWrap);
			$el.data('carousel-pause-play-loaded', $pausePlayBtns);
		}
		if (settings.pagination && !$el.data('carousel-pagination-loaded')) {
			$controlsWrap.addClass('carouselPagination carouselPagination' + settings.pagination.charAt(0).toUpperCase() + settings.pagination.slice(1));
			for (i; i <= lastSlideIndex; i += 1) {
				html += '<button class="ancBtn silver sml" type="button" data-carousel-slide="' + (i) + '" data-carousel-id="' + elId + '">';
				if (settings.pagination === 'numbers') {
					html += (i + 1);
				}
				html += '</button>';
			}
			$pagination = $(html);
			$pagination.appendTo($controlsWrap);
			$el.data('carousel-pagination-loaded', $pagination);
		}
		if (settings.showPrevNextBtns && !$el.data('carousel-prev-next-loaded')) {
			/* Add previous / next controls */
			$prevNextBtns = $('<button class="carouselPreviousBtn icon iconArrowLeft" type="button" data-carousel-slide="previous" data-carousel-id="' + elId + '"></button><button class="carouselNextBtn icon iconArrowRight" type="button" data-carousel-slide="next" data-carousel-id="' + elId + '"></button>');
			$prevNextBtns.appendTo($controlsWrap);
			$controlsWrap.find('.carouselPreviousBtn').prependTo($controlsWrap);
			$el.data('carousel-prev-next-loaded', $prevNextBtns);
		}
	}
	function getClosestSlide($el, fromWhatLeftPosition) {
		var settings = $el.data('carousel'),
			$slides = $el.data('$carouselSlides'),
			$slide,
			closestSlidePosition = null,
			closestSlideIndex = null;
		if (settings.fullWidth) {
			return false;
		}
		if (!fromWhatLeftPosition) {
			fromWhatLeftPosition = getLeftPosition($el, settings);
		}
		$.each($slides, function (slideIndex) {
			$slide = $(this);
			if (closestSlidePosition === null || Math.abs($slide.data('carousel-position') - fromWhatLeftPosition) < Math.abs(closestSlidePosition - fromWhatLeftPosition)) {
				closestSlidePosition = $slide.data('carousel-position');
				closestSlideIndex = slideIndex;
			}
		});
		return closestSlideIndex;
	}
	function addTouchEvents($el) {
		/* Do not change from here down. iOS works like this... */
		var settings = $el.data('carousel'),
			$inner = $el.data('$carouselInner'),
			$currentSlide,
			innerLeftPos,
			minDistance = 15, /* "right" number for mobile chrome */
			startX = 0,
			startY = 0,
			change = 0,
			currentX = 0,
			currentY = 0,
			currentXDistance,
			currentYDistance,
			isScrolling,
			newSlideIndex,
			touchStartTime,
			touchEndTime,
			touchSpeed;
		$inner
			.on('touchstart.carousel', function (e) {
				$inner
					.css({
						'-webkit-transition': 'none',
						'transition': 'none'
					});
				touchStartTime = new Date().getTime();
				isScrolling = undefined;
				currentX = 0;
				currentY = 0;
				currentXDistance = 0;
				currentYDistance = 0;
				startX = e.originalEvent.touches ? e.originalEvent.touches[0].pageX : e.pageX;
				startY = e.originalEvent.touches ? e.originalEvent.touches[0].pageY : e.pageY;
				$currentSlide = $el.data('$currentSlide');
				if (settings.showPreviews) {
					innerLeftPos = -$currentSlide.position().left - parseInt($currentSlide.css('margin-left'), 10);
				} else if (settings.fullWidth) {
					innerLeftPos = -$inner.width() * $currentSlide.index();
				} else {
					innerLeftPos = getLeftPosition($el, settings);
				}
			})
			.on('touchmove.carousel', function (e) {
				currentX = e.originalEvent.touches ? e.originalEvent.touches[0].pageX : e.pageX;
				currentY = e.originalEvent.touches ? e.originalEvent.touches[0].pageY : e.pageY;
				change = currentX - startX;
				currentXDistance = (startX === 0) ? 0 : Math.abs(change);
				currentYDistance = (startY === 0) ? 0 : Math.abs(currentY - startY);
				$inner.css(buildAnimation(innerLeftPos + change + 'px', {}, settings));
				if (typeof isScrolling === 'undefined') {
					isScrolling = !!(isScrolling || currentXDistance < currentYDistance);
				}
				if (!isScrolling) {
					e.preventDefault();
					/* paused autoscroll here */
					if (settings.autoscroll && currentXDistance > minDistance) {
						pauseAutoscroll($el, true);
					}
				}
			})
			.on('touchend.carousel', function () {
				$inner
					.css({
						'-webkit-transition': settings.innerTransition,
						'transition': settings.innerTransition
					});
				/* Make sure swipe is greater than minDistance */
				if (!isScrolling && currentXDistance > minDistance) {
					touchEndTime = new Date().getTime();
					touchSpeed = Math.abs(touchEndTime - touchStartTime);
					/* removed condition here and moved it above */
					if (settings.fullWidth || touchSpeed < 340) {
						if (currentX < startX) {
							goToSlide($el, 'next');
						} else if (currentX > startX) {
							goToSlide($el, 'previous');
						}
						/* removed condition here and moved it above */
					} else {
						newSlideIndex = getClosestSlide($el);
						goToSlide($el, newSlideIndex);
						return false;
					}
				} else {
					$inner.css(buildAnimation(innerLeftPos + change, {}, settings));
				}
				change = 0;
				currentX = 0;
				currentY = 0;
				currentXDistance = 0;
				currentYDistance = 0;
				startX = 0;
				startY = 0;
			});
	}
	function addEvents($el) {
		var settings = $el.data('carousel'),
			elMatchingIdAttr = '[data-carousel-id="' + $el.attr('id') + '"]',
			winWidth = $(window).width(),
			winHeight = $(window).height(),
			winNewWidth,
			winNewHeight,
			firstResize = true;
		/* Adjust dimensions on browser resize */
		$(window).on('resize.carousel.' + $el.attr('id'), function () {
			winNewWidth = $(window).width();
			winNewHeight = $(window).height();
			if (winWidth !== winNewWidth || winHeight !== winNewHeight) {
				if (settings.autoscroll && $el.hasClass('carouselPlaying') && firstResize === true) {
					pauseAutoscroll($el);
					firstResize = false;
				}
				clearTimeout($el.data('carousel-resize-timer' + $el.attr('id')));
				$el.data('carousel-resize-timer' + $el.attr('id'), setTimeout(function () {
					setPositions($el);
					goToSlide($el, $el.data('$currentSlide').index(), true);
					if (settings.autoscroll && $el.hasClass('carouselPaused')) {
						playAutoscroll($el);
					}
					firstResize = true;
				}, 400));
			}
			winWidth = winNewWidth;
			winHeight = winNewHeight;
		});
		/* Autoscroll hover / blur */
		if (settings.autoscroll) {
			$el
				.on('mouseover.carousel', function () {
					if ($el.hasClass('carouselPlaying')) {
						pauseAutoscroll($el);
					}
				})
				.on('mouseleave.carousel', function () {
					if ($el.hasClass('carouselPaused')) {
						playAutoscroll($el);
					}
				});
		}
		if (Carousel.isTouchDevice) {
			addTouchEvents($el);
		}
		/* Add events on controls (previous, next, pagination btns) */
		$el.find('.carouselNextBtn').attr('data-carousel-slide', 'next');
		$el.find('.carouselPreviousBtn').attr('data-carousel-slide', 'previous');
		$el.find('[data-carousel-slide]').attr('data-carousel-id', $el.attr('id'));
		bindControls($el, elMatchingIdAttr);
	}
	function bindControls($el, $controls, isCustomControls) {
		var settings = $el.data('carousel');
		$($controls).each(function () {
			var $btn = $(this);
			if ($btn.hasClass(settings.pausePlayBtnClass)) {
				if (settings.autoscroll) {
					if (isCustomControls) {
						if ($('#' + $btn.attr('data-carousel-id')).hasClass('carouselPlaying')) {
							$btn
								.addClass('iconPause')
								.removeClass('iconPlay');
						} else {
							$btn
								.addClass('iconPlay')
								.removeClass('iconPause');
						}
					}
					$btn.on('click.carousel', function () {
						var $btns = $('.' + settings.pausePlayBtnClass + '[data-carousel-id="' + $el.attr('id') + '"]');
						if ($btn.hasClass('iconPause')) {
							$btns
								.removeClass('iconPause')
								.addClass('iconPlay');
							pauseAutoscroll($el, true);
						} else {
							$btns
								.removeClass('iconPlay')
								.addClass('iconPause');
							if ($el.hasClass('carouselIsLastSlide')) {
								goToSlide($el, 0);
							} else {
								goToSlide($el, $el.data('$currentSlide').index() + 1);
							}
							playAutoscroll($el);
						}
					});
				} else {
					if (window.console) {
						console.warn('The carousel you are trying to bind a pause / play button to (#' + $el.attr('id') + ') is not currently set to autoscroll. To make it autoscroll you will need to destroy and re-create it passing the \'autoscroll\' setting.');
					}
					return false;
				}
			} else {
				$btn.on('click.carousel', function () {
					$el = $('#' + $btn.attr('data-carousel-id'));
					if (settings.autoscroll) {
						pauseAutoscroll($el, true);
					}
					goToSlide($el, $btn.attr('data-carousel-slide'));
				});
			}
		});
	}
	function destroyCarousel($el) {
		var settings = $el.data('carousel'),
			$slides = $el.data('$carouselSlides'),
			elMatchingIdAttr = '[data-carousel-id="' + $el.attr('id') + '"]',
			$defaultControls = $el.find('.carouselControlsDefault');
		if (settings.autoscroll) {
			pauseAutoscroll($el, true);
		}
		/* Remove events from all controls */
		$(elMatchingIdAttr)
			.removeClass('active')
			.addClass('disabled')
			.attr('disabled', 'disabled')
			.off('.carousel');
		$(window).off('resize.carousel.' + $el.attr('id'));
		/* Clear resize timeout in case carousel is destroyed at the same time as a window resize event */
		clearTimeout($el.data('carousel-resize-timer' + $el.attr('id')));
		/* Remove default controls that were added */
		$defaultControls.remove();
		/* Remove stored data from $slides */
		$slides
			.removeData('carousel-position carousel-loaded');
		/* Remove data and events from $el */
		$el
			.removeClass(settings.activeSlideClass + ' carouselAutoscroll carouselPlaying carouselPaused carouselIsFirstSlide carouselIsLastSlide')
			.removeAttr('style')
			.removeData('carousel $carouselInner $carouselSlides $currentSlide $carouselGoToSlideBtns $lastSlide carousel-timer carousel-prev-next-loaded carousel-pagination-loaded carousel-pause-play-loaded')
			.off('.carousel');
	}
	function init($el, settings) {
		var $inner,
			$slides,
			firstSlideIndex,
			elMatchingIdAttr = '[data-carousel-id="' + $el.attr('id') + '"]',
			transitionType;
		/* Store variables */
		settings = $el.data('carousel', $.extend({}, Carousel.defaults, settings)).data('carousel');
		/* We create a setting to use transforms only for full-width carousels without previews. */
		/**
		 * TODO:
		 * On iPhone5, for carousels with previews, the 2nd slide disappears then reappears a couple hundred
		 * milliseconds later.
		 * For gallery carousels (non full-width), we just need to adjust the logic and test thoroughly before
		 * enabling transforms.
		 */
		settings.useTransforms = !!settings.fullWidth && !settings.showPreviews;
		firstSlideIndex = settings.firstSlide - 1;
		/* (For backwards compatibility) If .carouselInner doesn't exist, use <ul/> child of .carousel; otherwise return false */
		if (!$el.find('.carouselInner').length) {
			if ($el.find('ul').length) {
				$el
					.find('ul')
					.addClass('carouselInner')
					.find('li')
					.addClass('carouselSlide');
			} else {
				if (window.console) {
					console.warn('There is no .carouselInner element inside of #' + $el.attr('id') + '. Please make sure your markup is correct.')
				}
				return false;
			}
		}
		/* Store variables for global use */
		$el
			.addClass('carousel')
			.data('$carouselInner', $el.find('.carouselInner'))
			.data('$carouselSlides', $el.find('.carouselSlide'));
		$inner = $el.data('$carouselInner');
		$slides = $el.data('$carouselSlides');
		$el.data('$currentSlide', $slides.eq(firstSlideIndex));
		/* Add class to last slide in IE8 to allow for certain styles */
		if ($('.ie8').length) {
			$slides
				.eq(-1)
				.addClass('carouselSlideLast');
		}
		/* Set defaults for certain use cases */
		if (settings.fullWidth) {
			$el.addClass('carouselFullWidth');
			/* fullWidth carousels should always scroll by 1 */
			settings.slidesPerScroll = 1;
			if (settings.carouselHeight === 'varied') {
				$el.addClass('carouselVariedHeight');
			}
		} else {
			/* If carousel is not full width carouselHeight should not be 'varied' */
			if (settings.carouselHeight === 'varied') {
				settings.carouselHeight = 'auto';
			}
		}
		/* Add style class for carousel previews */
		if (settings.showPreviews) {
			$el.addClass('carouselWithPreview');
		}
		/* Remove disabled class from buttons tied to this carousel (for when carousel was previously destroyed) */
		$(elMatchingIdAttr).removeAttr('disabled').removeClass('disabled ' + settings.disabledBtnClass);
		/* Add CSS transition */
		transitionType = settings.useTransforms ? 'transform ' : 'left ';
		settings.innerTransition = transitionType + settings.scrollTime + 'ms, height ' + settings.scrollTime + 'ms';
		$inner.css({
			'-webkit-transition': settings.innerTransition,
			'transition': settings.innerTransition
		});
		/* Activate carousel & show content (setTimeout to ensure content loads) */
		setTimeout(function () {
			addControlsHtml($el);
			/* setPositions sets the scroll position for each slide */
			setPositions($el);
			/* Add events */
			addEvents($el);
			$el.removeClass('loading');
			goToSlide($el, firstSlideIndex, true);
			if (settings.autoscroll) {
				if (settings.playOnLoad) {
					playAutoscroll($el);
				} else {
					pauseAutoscroll($el, true);
				}
			}
		}, 600);
	}
	$.fn.carousel = function (options, params) {
		return this.each(function () {
			var $this = $(this);
			if (!$this.attr('id')) {
				$this.attr('id', 'carousel-' + (new Date()).getTime() + Math.ceil(Math.random() * 10000));
			}
			if (options === 'next') {
				/* For backwards compatibility */
				goToSlide($this, 'next');
			} else if (options === 'prev' || options === 'previous') {
				/* For backwards compatibility */
				goToSlide($this, 'previous');
			} else if (options === 'goToSlide') {
				if (isNaN(params)) {
					goToSlide($this, params);
				} else {
					goToSlide($this, params - 1);
				}
			} else if (options === 'stop' && $this.data('carousel').autoscroll) {
				pauseAutoscroll($this, true);
			} else if (options === 'play' && $this.data('carousel').autoscroll) {
				playAutoscroll($this);
			} else if (options === 'fixDimensions' || options === 'setPositions') {
				setPositions($this);
			} else if (options === 'bindControls') {
				bindControls($this, params, true);
			} else if (options === 'destroy') {
				destroyCarousel($this);
			} else if (!$this.data('carousel')) {
				/* Prevents multiple instantiations */
				init($(this), options);
			}
		});
	};
	/* Detect touch device and add appropriate class */
	$(function () {
		if (Carousel.isTouchDevice) {
			$('html').addClass('touch');
		} else {
			$('html').addClass('noTouch');
		}
	});
	/* Defaults */
	$.carousel = {
		'version': version
	};
}(jQuery));